/*
 * @FilePath: \hotOrder-frontend\src\router\modules\suggestCollect.js
 * @Description: 人民意见征集路由
 */
import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};

export default {
  path: "/suggestCollect",
  name: "suggestCollect",
  redirect: {
    name: "suggestCollect",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/suggestCollect/suggestList",
      name: "suggestList",
      meta: {
        ...meta,
        title: "议题管理",
      },
      component: () => import("@/pages/suggestCollect/suggestList.vue"),
    },
    {
      path: "/suggestCollect/issueList",
      name: "issueList",
      meta: {
        ...meta,
        title: "建议管理",
      },
      component: () => import("@/pages/suggestCollect/issueList.vue"),
    },
    {
      path: "/suggestCollect/issueDetail",
      name: "issueDetail",
      meta: {
        ...meta,
        title: "建议详情",
      },
      component: () => import("@/pages/suggestCollect/issueDetail.vue"),
    },
    {
      path: "/suggestCollect/suggestReplyDetail",
      name: "suggestReplyDetail",
      meta: {
        ...meta,
        title: "议题回复详情",
      },
      component: () => import("@/pages/suggestCollect/suggestReplyDetail.vue"),
    },
    {
      path: "/suggestCollect/suggestOverview",
      name: "suggestOverview",
      meta: {
        ...meta,
        title: "统计总览",
      },
      component: () => import("@/pages/suggestCollect/suggestOverview.vue"),
    },
    {
      path: "/suggestCollect/adviceList",
      name: "adviceList",
      meta: {
        ...meta,
        title: "抄送建议",
      },
      component: () => import("@/pages/suggestCollect/adviceList.vue"),
    },

    {
      path: "/suggestCollect/congressSuggestion",
      name: "congressSuggestion",
      meta: {
        ...meta,
        title: "南康区人民代表大会代表建议、批评和意见",
      },
      component: () => import("@/pages/suggestCollect/congressSuggestion.vue"),
    },
  ],
};
